import React, { useState, useEffect } from 'react';

import Grid from '@material-ui/core/Grid';

import VideoPlayer from '../components/video/VideoPlayer';
import Description from '../components/agenda/Description';
import Tabs from '../components/agenda/Tabs';
import Slido from '../components/plugins/Slido';

export default (props) => {
  const [playerSrc, setPlayerSrc] = useState(props.config.defaultVideo);
  const [childSrc, setChildSrc] = useState(playerSrc);
  useEffect(() => {
    setPlayerSrc(childSrc);
  }, [childSrc]);
  const updateVideoFromChild = (videoUrl, videoId, videoTitle) => {
    setChildSrc((prevState) => ({ ...prevState, videoUrl: videoUrl, videoId: videoId, videoTitle: videoTitle }));
  }
  useEffect(() => {
    // reload the video if the src has been updated in the config file
    if (playerSrc.videoId === props.config.defaultVideo.videoId  && playerSrc.videoUrl !== props.config.defaultVideo.videoUrl) {
      setChildSrc(props.config.defaultVideo);
    } else {
      for (let i = 0; i < props.config.days.length; i++) {
        const day = props.config.days[i];
        for (let j = 0; j < day.sessions.length; j++) {
          const session = day.sessions[j];
          for (let k = 0; k < session.rooms.length; k++) {
            const room = session.rooms[k];
            for (let l = 0; l < room.events.length; l++) {
              const event = room.events[l];
              if (playerSrc.videoId === event.videoId  && playerSrc.videoUrl !== event.videoUrl) {
                setChildSrc((prevState) => ({ ...prevState, videoUrl: event.videoUrl, videoId: event.videoId, videoTitle: event.videoTitle }));
              }
            }
          }
        }
      }
    }
  }, [playerSrc, props.config]);

  return (
    <div className="container-event">
      <Grid container direction="row" spacing={3}>
        <Grid item md={8} xs={12}>
          <VideoPlayer src={playerSrc} userId={props.user.attributes.email} />
          <Description config={props.config} />
        </Grid>
        <Grid item md={4} xs={12} style={{marginBottom: '24px'}}>
          <Slido title="Live Chat" eventCode={props.config.slidoEventCode} firstname={props.user.attributes.given_name} surname={props.user.attributes.family_name} email={props.user.attributes.email} />
        </Grid>
        <Grid item md={8} xs={12}>
          <Tabs config={props.config} setVideoSrc={updateVideoFromChild} />
        </Grid>
        <Grid item md={4} xs={12}>
        </Grid>

      </Grid>
    </div>
  );
}
